import { Component, input } from '@angular/core';
import { IconNames } from 'projects/components/pay-icon/IconNames';
import { DateAgoPipe } from '../../../../utils/date-ago/date-ago.pipe';
import { IconComponent } from 'projects/components/pay-icon/icon.component';

@Component({
  selector: 'pay-login-news-item',
  imports: [DateAgoPipe, IconComponent],
  templateUrl: './news-item.component.html',
})
export class NewsItemComponent {
  readonly newsItem = input<NewsItem>();
  protected readonly IconNames = IconNames;
}

export interface NewsItem {
  date: Date;
  title: string;
  summary: string;
  id: string;
  link: string;
  imageSrc: string;
}
